import { PillButton } from "@/components/ui/buttons/PillButton";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { IonSkeletonText } from "@ionic/react";
import { memo } from "react";

interface SearchTagsProps {
  tags?: string[];
  isLoading: boolean;
  onTagClick: (tag: string) => void;
}

export const SearchTags = memo(function SearchTags({
  tags,
  isLoading,
  onTagClick,
}: SearchTagsProps) {
  if (isLoading) {
    return (
      <div className="mt-5 flex flex-col gap-9">
        <IonSkeletonText animated className="h-6 w-32" />
        <div className="flex flex-wrap gap-2">
          {[...Array(6)].map((_, index) => (
            <IonSkeletonText key={index} animated className="h-10 w-24 rounded-full" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="mt-5 flex flex-col gap-9">
      <h3 className={textVariants.title3}>Maybe try these:</h3>
      <div className="flex flex-wrap gap-x-2 gap-y-3">
        {tags?.map((tag, index) => (
          <PillButton key={index} onClick={() => onTagClick(tag)} className="bg-white px-6 py-3">
            <span className={cn(textVariants.bodySmall, "font-medium")}>{tag}</span>
          </PillButton>
        ))}
      </div>
    </div>
  );
});
